import HistoryPage from './history-page';

export default function HistoryGridPage() {
  return <HistoryPage />;
}
